module.exports = __webpack_public_path__ + "img/brecv_ban.png";